import { AfterViewInit, Component, inject, input, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatInput } from '@angular/material/input';
import { Title } from '@angular/platform-browser';

import { IPaginationValue, PaginationComponent } from '../../shared/components/pagination/pagination.component';
import { PrintFilterDataComponent } from '../../shared/components/print-filter-data/print-filter-data.component';
import { IIncentiveReport, IIncentiveReportDraw, IIncentiveReportPagination } from '../../utils/interfaces/incentive';
import { IReportFilter } from '../../utils/interfaces/report-filter';
import { IUnit } from '../../utils/interfaces/unit';
import { PrintDocument } from '../print-document';

@Component({
  selector: 'app-print-incentive',
  standalone: true,
  host: {
    '[class.embedded]': 'embedded()',
  },
  imports: [
    PrintFilterDataComponent,
    DatePipe,
    FormsModule,
    MatInput,
    PaginationComponent,
  ],
  templateUrl: '../../main/report/report-data/incentive/incentive.component.html',
  styleUrls: ['../../main/report/report-data/incentive/incentive.component.scss'],
  styles: [
    `
      :host.embedded app-print-filter-data {
        display: none;
      }
    `,
  ],
})
export class PrintIncentiveComponent extends PrintDocument
  implements OnInit, AfterViewInit
{
  embedded = input(false);
  embeddedData = input<IIncentiveReportPagination[] | null>(null);
  embeddedFilter = input<IReportFilter | null>(null);

  private readonly titleService = inject(Title);
  print = true;

  data: IIncentiveReportPagination[] = [];
  filter!: IReportFilter;
  orientation = 'landscape';

  unit: IUnit[] = [];

  get today(): Date {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    return d;
  }

  isIncentiveExpired(endDate: string | Date): boolean {
    if (!endDate) return false;
    const end = new Date(endDate);
    end.setHours(0, 0, 0, 0);
    return end < this.today;
  }

  ngOnInit(): void {
    this.handleData();
  }

  ngAfterViewInit(): void {
    this.reportReadyData();
  }

  protected override handleData(): void {
    if (this.embedded()) {
      this.data = this.embeddedData() ?? [];
      this.filter = this.embeddedFilter() as IReportFilter;
      return;
    }

    const data = this.activatedRoute.snapshot.data['data'];

    this.data = data.dataIncentive;
    this.filter = data.filter;

    this.titleService.setTitle(
      this.changeTitlePage(
        'Relatório de incentivo',
        this.filter.startDate,
        this.filter.finishDate
      )
    );
  }

  protected override reportReadyData(): void {
    if (this.embedded()) {
      return;
    }

    setTimeout(() => {
      this.printDocumentService.onDataReady();
    }, 3000);
  }

  onPaginationChange(
    event: IPaginationValue,
    incentive: IIncentiveReportPagination
  ): void {
    incentive.pagination = event;
  }

  winnerDelivery(draw: IIncentiveReportDraw): void {
  }

  exportToPdf(incentive: IIncentiveReport): void {
  }

  drawDataPagination(incentiveId: string): IIncentiveReportDraw[] {
    if (!this.data || this.data.length === 0) {
      return [];
    }

    const incentiveIndex = this.data.findIndex((d) => d.id === incentiveId);

    if (incentiveIndex === -1) {
      return [];
    }

    const incentive = this.data[incentiveIndex];

    if (!incentive.draws || incentive.draws.length === 0) {
      return [];
    }
    return incentive.draws;
  }
}
